module.exports = "<a ui-sref=\"companias.proyectos.empresas.dashboard.herramientas()\">\r\n  <app-launcher color=\"#3F51B5\">\r\n    <icon>Hr</icon>\r\n    <label>Herramientas</label>\r\n  </app-launcher>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/components/herramientas/template.html
// module id = 9
// module chunks = 0